var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPathSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 4.8 4.8 0 24 0C43.2 0 48 4.8 48 24C48 43.2 43.2 48 24 48C4.8 48 0 43.2 0 24Z",
    fill: "#8282FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.285 9H17.715C12.255 9 9 12.255 9 17.715V30.27C9 35.745 12.255 39 17.715 39H30.27C35.73 39 38.985 35.745 38.985 30.285V17.715C39 12.255 35.745 9 30.285 9Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9899 22.8757L28.5599 24.4057L23.6099 19.4707L25.1549 17.0257C25.8599 15.9157 27.2999 15.8557 28.3499 16.9057L31.1249 19.6807C32.1149 20.6557 32.0549 22.2007 30.9899 22.8757Z",
    fill: "#111827"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M26.3699 30.9305L18.7649 31.8305C18.4349 31.8755 18.1349 31.8605 17.8499 31.7705C17.0249 31.5905 16.4399 31.0055 16.2599 30.1805C16.1699 29.8955 16.1549 29.5955 16.1999 29.2655L17.0849 21.6605C17.3249 19.7555 18.0149 19.1405 20.0249 19.2605L23.6099 19.4705L28.5599 24.4055L28.7699 28.0055C28.9649 30.0155 28.2749 30.7055 26.3699 30.9305Z",
    fill: "#111827"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8198 28.7991L17.8498 31.7691C17.0248 31.5891 16.4398 31.0041 16.2598 30.1791L19.2148 27.2091C19.6648 26.7741 20.3698 26.7741 20.8198 27.2091C21.2548 27.6441 21.2548 28.3641 20.8198 28.7991Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPathSquare);
export default __webpack_public_path__ + "static/media/pathSquare.d47da5a42feca8c8afd7cc8ef17ff14c.svg";
export { ForwardRef as ReactComponent };